<template>
  <div class="detail-page">
    <!-- 拒审记录 -->
    <reject-list
      v-if="permissionInfo && permissionInfo.is_show_rejects"
      :data="rejectData"
    />
    <my-form
      ref="myForm"
      :data="baseFormData"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import RejectList from './RejectList'
import MyForm from './Form'

export default {
  components: {
    MyForm,
    RejectList
  },
  props: {
    formData: {
      type: Object,
      default: () => { }
    },
    rejectData: {
      type: [Object, Array],
      default: () => { }
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),
    fromInfoOptions () {
      const { from_info: fromInfo = {} } = this.formData || {}
      const { child = [] } = fromInfo

      let arr = child.map(item => {
        return {
          name: item.fieldname,
          id: item.fieldkey
        }
      })

      return arr
    },
    inquiryInfoChild () { // 审核详情的人员信息
      const { childObj = {} } = this.memberInfo || {}

      const inputData = childObj.input || {}
      const auditData = childObj.audit || {}
      const devData = childObj.dev || {}
      const followData = childObj.follow || {}

      let auditTrueName = auditData.info && auditData.info.truename
      if (auditData.info && auditData.info.status === 0) { // 待审核
        auditTrueName = this.baseinfo && this.baseinfo.truename
      }

      const inputObj = {
        ...inputData,
        fieldvalue: (inputData.info && inputData.info.truename) || '- -'
      }
      const auditNameObj = {
        ...auditData,
        fieldkey: 'auditName',
        fieldvalue: auditTrueName || '- -'
      }
      const groupObj = {
        fieldkey: 'group',
        key: 'audit',
        fieldname: this.$t('message["1159"]'),
        fieldtype: 'cascader',
        fieldvalue: [],
        isneeded: 1,
        messages: { required: this.$t('message["879"]') },
        rules: {
          required: true
        },
        info: auditData.info
      }
      let devObj = {
        ...devData,
        key: 'dev',
        fieldtype: 'cascader',
        fieldvalue: []
      }

      let followObj = {
        ...followData,
        key: 'follow',
        fieldtype: 'cascader',
        fieldvalue: []
      }

      let data = [inputObj, auditNameObj, groupObj, devObj, followObj]

      if (this.permissionInfo.is_show_approval === 0 && this.permissionInfo.is_show_reapproval === 0) {
        devObj.fieldtype = 'string'
        followObj.fieldtype = 'string'
        data = [inputObj, devObj, followObj]
      }

      return data
    },
    newFormData () {
      for (let key in this.formData) {
        let modules = this.formData[key]
        modules.show = true
        modules.spread = true
        if (this.$toType(modules) !== 'object' || key === 'audit_info') {
          delete this.formData[key]
        }
        if (!modules.child || !modules.child.length) {
          modules.show = false
        }
      }

      return this.formData
    },
    baseFormData () {
      if (!this.formData) return

      const { info: inquiryInfo = {} } = this.formData || {}
      /* if (baseInfo.child && baseInfo.child.length) {
        baseInfo.child[0].fieldname = '录入时间'
      } */

      const data = {
        ...this.newFormData,
        info: {
          ...inquiryInfo,
          child: this.inquiryInfoChild,
          show: true
        }
      }
      // data.from_info.options = this.fromInfoOptions

      return data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
